"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentStore = exports.ContentServiceV1 = void 0;
const events_1 = require("events");
class ContentServiceV1 {
    constructor(consumerId, store) {
        this.consumerId = consumerId;
        this.store = store;
    }
    getContent() {
        return this.store.getContent(this.consumerId);
    }
    setContent(content) {
        this.store.setContent(this.consumerId, content);
    }
    onContentChange(listener) {
        this.store.onContentChange(this.consumerId, listener);
    }
    removeOnContentChange(listener) {
        this.store.removeOnContentChange(this.consumerId, listener);
    }
}
exports.ContentServiceV1 = ContentServiceV1;
class ConsumerStore {
    constructor() {
        this.content = undefined;
        this.eventEmitter = new events_1.EventEmitter();
    }
    setContent(content) {
        this.content = content;
        this.eventEmitter.emit(ConsumerStore.EVENT_NAME, content);
    }
    getContent() {
        return this.content;
    }
    addListener(listener) {
        this.eventEmitter.addListener(ConsumerStore.EVENT_NAME, listener);
    }
    removeListener(listener) {
        this.eventEmitter.removeListener(ConsumerStore.EVENT_NAME, listener);
    }
}
ConsumerStore.EVENT_NAME = "update";
class ContentStore {
    constructor() {
        this.consumerStores = {};
    }
    getOrCreateConsumerStore(consumerId) {
        const store = this.consumerStores[consumerId];
        if (store !== undefined) {
            return store;
        }
        const newStore = new ConsumerStore();
        this.consumerStores[consumerId] = newStore;
        return newStore;
    }
    getContent(consumerId) {
        return this.getOrCreateConsumerStore(consumerId).getContent();
    }
    setContent(consumerId, content) {
        this.getOrCreateConsumerStore(consumerId).setContent(content);
    }
    onContentChange(consumerId, listener) {
        this.getOrCreateConsumerStore(consumerId).addListener(listener);
    }
    removeOnContentChange(consumerId, listener) {
        this.getOrCreateConsumerStore(consumerId).removeListener(listener);
    }
}
exports.ContentStore = ContentStore;
//# sourceMappingURL=v1.js.map